import React from "react";
import withStyles from "isomorphic-style-loader/withStyles";
import {
  Row,
  Col,
  InputGroup,
  InputGroupText,
  Input,
  Button,
} from "reactstrap";
import ModalFrame from "../../../toolkit/modalFrame";
import s from "./styles.scss";
import classNames from "classnames";
import { ScaleLoader } from "react-spinners";
import { serviceCaller, ServiceCallerProps } from "../../composition";
import IUser from "../../../types/services/IUser";
import {
  paginateDonors,
  searchDonors,
  updateSegmentMembersBatched,
} from "../../../utils/fetch";
import Fragment from "../../../toolkit/fragment";

interface Props extends ServiceCallerProps {
  donorFlagId: string;
  isOpen: boolean;
  toggle: () => void;
  donorFlagDonors: Array<string>;
}

type DisplayState = "normal" | "confirm" | "success";

interface State {
  loaded: boolean;
  displayState: DisplayState;
  fetchMessage: string;
  isError: boolean;
  searchText: string;
  searchTextUsed: string;
  showedDonors: Array<IUser>;
  currentPage: number;
  selectedDonors: Array<string>;
  errorText: string;
  totalPages: number;
}

class addDonorModal extends React.Component<Props, State> {
  constructor(props) {
    super(props);

    this.state = {
      loaded: false,
      displayState: "normal" as DisplayState,
      fetchMessage: null,
      isError: false,
      searchText: "",
      searchTextUsed: "",
      showedDonors: [],
      currentPage: 0,
      selectedDonors: [],
      errorText: "",
      totalPages: 0,
    };
  }

  searchTimeout = null;

  componentDidUpdate(prevProps: Props, prevState: State) {
    if (prevProps.isOpen && !this.props.isOpen) {
      this.setState({ loaded: false });
    }

    if (prevProps.isOpen && !this.props.isOpen) {
      this.setState({
        loaded: false,
        currentPage: 0,
        showedDonors: [],
        selectedDonors: [],
        searchText: undefined,
        searchTextUsed: undefined,
        displayState: "normal",
        errorText: undefined,
      });
    }
    if (prevState.searchTextUsed != this.state.searchTextUsed) {
      this.getResponse(this.state.searchTextUsed, 0).then(response => {
        let sortedArray = [...response.result];
        sortedArray.sort(this.customCompare("firstName"));
        this.setState({
          showedDonors: sortedArray,
          errorText: undefined,
        });
      });
    }
    if (!this.state.loaded && this.props.config && this.props.isOpen) {
      this.getResponse(undefined, this.state.currentPage).then(response => {
        let sortedArray = [...response.result];
        sortedArray.sort(this.customCompare("firstName"));
        this.setState({
          loaded: true,
          fetchMessage: null,
          currentPage: 1,
          showedDonors: sortedArray,
          totalPages: response.pageAmount,
        });
      });
    }
  }

  componentWillUnmount(): void {
    if (this.searchTimeout && window) {
      window.clearTimeout(this.searchTimeout);
      this.searchTimeout = null;
    }
  }

  customCompare = fieldName => {
    return (a, b) => {
      if (!a[fieldName]) {
        return 1;
      } else if (!b[fieldName]) {
        return -1;
      } else if (a[fieldName] === b[fieldName]) {
        return 0;
      } else if (a[fieldName] < b[fieldName]) {
        return -1;
      } else {
        return 1;
      }
    };
  };

  checkScroll = el => {
    if (
      el.target.scrollHeight - el.target.scrollTop <= 600 &&
      (!this.state.searchTextUsed || this.state.searchTextUsed === "") &&
      this.state.currentPage < this.state.totalPages
    ) {
      this.getResponse(undefined, this.state.currentPage).then(response => {
        let newArray = [...this.state.showedDonors];
        response.result.forEach(elem => {
          if (!newArray.includes(elem)) {
            newArray.push(elem);
          }
        });
        newArray.sort(this.customCompare("firsName"));
        this.setState({
          showedDonors: newArray,
          currentPage: this.state.currentPage + 1,
        });
      });
    }
  };

  onCheckElem = donorId => {
    let newArray = [...this.state.selectedDonors];
    if (this.state.selectedDonors.includes(donorId)) {
      let index = newArray.indexOf(donorId);
      newArray.splice(index, 1);
    } else {
      newArray.push(donorId);
    }
    this.setState({
      selectedDonors: newArray,
      errorText: undefined,
    });
  };

  getCheckElem = donorId => {
    return this.state.selectedDonors.includes(donorId);
  };

  getResponse = (searchTextUsed, currentPage) => {
    return !searchTextUsed || searchTextUsed === ""
      ? paginateDonors(
          this.props.config.searchServiceUrl,
          this.props.currentCharity.id,
          currentPage,
          300,
          "ACCOUNT",
          true,
          this.props.serviceAccessToken,
          undefined,
          null,
          null,
          true
        )
      : searchDonors(
          this.props.config.searchServiceUrl,
          this.props.currentCharity.id,
          300,
          0,
          this.state.searchTextUsed,
          this.props.serviceAccessToken,
          "ACCOUNT",
          true,
          undefined,
          null,
          null,
          true,
          true
        );
  };

  getDonorsToShow = () => {
    let newArray = this.state.showedDonors.filter(
      donor =>
        !this.props.donorFlagDonors ||
        !this.props.donorFlagDonors.includes(donor.id)
    );
    return (
      <Fragment>
        <Row key={"header"}>
          <Col xs={1} className={s.offsetHeader} />
          <Col xs={1} className={s.headerDiv}>
            Contact #
          </Col>
          <Col xs={3} md={2} className={s.headerDiv}>
            Name
          </Col>
          <Col xs={2} md={3} className={s.headerDiv}>
            Company
          </Col>
          <Col xs={2} md={2} className={s.headerDiv}>
            Mobile Number
          </Col>
          <Col xs={3} md={3} className={classNames(s.lastCol, s.headerDiv)}>
            Email
          </Col>
        </Row>
        {newArray.map((donor, index) => (
          <Row key={donor.id} className={(index + 1) % 2 === 0 ? "" : s.oddRow}>
            <Col xs={1} className={s.borderR}>
              <div
                onClick={() => this.onCheckElem(donor.id)}
                className={s.checkBoxDiv}
              >
                <input
                  type="checkbox"
                  className="checkbox"
                  checked={this.getCheckElem(donor.id)}
                  onChange={() => {}}
                />
                <label
                  htmlFor="checkbox"
                  key={donor.id}
                  className={
                    this.getCheckElem(donor.id) ? s.checked : s.noCheck
                  }
                />
              </div>
            </Col>
            <Col xs={1} className={s.textDiv}>
              {donor.accountNumber}
            </Col>
            <Col xs={3} md={2} className={s.textDiv}>
              {donor.name ? donor.name : "Not Available"}
            </Col>
            <Col xs={2} md={3} className={s.textDiv}>
              {donor.company}
            </Col>
            <Col xs={2} md={2} className={s.textDiv}>
              {donor.phoneNumber}
            </Col>
            <Col xs={3} md={3} className={classNames(s.lastCol, s.textDiv)}>
              {donor.email}
            </Col>
          </Row>
        ))}
      </Fragment>
    );
  };

  searchTextChange = e => {
    const newText: string = e.target.value;
    if (!newText || newText.length >= 3 || newText.length == 0) {
      if (this.searchTimeout && window) {
        window.clearTimeout(this.searchTimeout);
        this.searchTimeout = null;
      }
      this.setState({
        searchText: newText,
        searchTextUsed: newText,
      });
    } else {
      if (window) {
        if (this.searchTimeout) {
          window.clearTimeout(this.searchTimeout);
        }
        this.setState({
          searchText: newText,
        });
        this.searchTimeout = window.setTimeout(() => {
          this.setState({
            searchTextUsed: newText,
          });
        }, 1500);
      }
    }
  };

  onAdd = () => {
    if (this.state.selectedDonors.length === 0) {
      this.setState({
        errorText: "You have to select at least 1 donor",
      });
    } else {
      this.setState({ displayState: "confirm" });
    }
  };

  addDonors = () => {
    updateSegmentMembersBatched(
      this.props.config.searchServiceUrl,
      this.props.currentCharity.id,
      this.props.donorFlagId,
      this.state.selectedDonors,
      [],
      this.props.serviceAccessToken
    ).then(
      () => {
        this.setState({
          currentPage: 0,
          loaded: false,
          displayState: "success",
          showedDonors: [],
          searchText: undefined,
          searchTextUsed: undefined,
        });
      },
      error => {
        console.error(error);
        this.setState({
          displayState: "normal",
          errorText: "Could not add contacts to this list",
        });
      }
    );
  };

  cancelAdd = () => {
    this.setState({ displayState: "normal" });
  };

  resetSearch = () => {
    this.setState({
      searchText: undefined,
      searchTextUsed: undefined,
      loaded: false,
      currentPage: 0,
      errorText: undefined,
    });
  };

  render() {
    return (
      <ModalFrame
        title={"Add Contact to Segment"}
        isOpen={this.props.isOpen}
        toggle={this.props.toggle}
        size="l"
        className={s["modal-l"]}
      >
        <div className={s.centered}>
          <ScaleLoader color={"#1f65b1"} loading={!this.state.loaded} />
        </div>
        {this.state.loaded && this.state.displayState === "normal" && (
          <div>
            <Row className={s.generalMargin}>
              <Col xs={12}>
                <InputGroup>
                  <InputGroupText
                    className={s.inputGroup}
                  >
                    <i className={"fa fa-search " + s.searchIcon}>&nbsp;</i>
                  </InputGroupText>
                  <Input
                    id="searchText"
                    placeholder={"Search Contact List"}
                    value={this.state.searchText}
                    onChange={this.searchTextChange}
                    className={s.text}
                  />
                  <InputGroupText
                    className={s.inputGroupRight}
                  >
                    <i
                      className={"fa fa-times " + s.closeIcon}
                      onClick={this.resetSearch}
                    >
                      &nbsp;
                    </i>
                  </InputGroupText>
                </InputGroup>
              </Col>
            </Row>
            <div
              className={classNames(s.hiddenScroll, "container-fluid")}
              onScroll={this.checkScroll}
            >
              {this.getDonorsToShow()}
            </div>
            {this.state.errorText && (
              <Row className={s.error}>
                <span className={s.centeredText}>{this.state.errorText}</span>
              </Row>
            )}
            <Row>
              <Button className={s.button} onClick={this.onAdd}>
                {`Add ${this.state.selectedDonors.length} Contacts`}
              </Button>
            </Row>
          </div>
        )}
        {this.state.loaded && this.state.displayState === "confirm" && (
          <div>
            <Row className={s.confirmMessage}>
              <span>
                Are you sure you want to add the selected Contacts to this
                Segment?
              </span>
            </Row>
            <Row>
              <Col xs={6} className={s.rightCol}>
                <Button className={s.button} onClick={this.cancelAdd}>
                  Cancel
                </Button>
              </Col>
              <Col xs={6} className={s.leftCol}>
                <Button className={s.button} onClick={this.addDonors}>
                  Accept
                </Button>
              </Col>
            </Row>
          </div>
        )}
        {this.state.loaded && this.state.displayState === "success" && (
          <div>
            <Row className={s.fetchMessage}>
              <span className={s.centeredText}>Donors Added Successfully</span>
            </Row>
            <Row>
              <Button className={s.button} onClick={this.props.toggle}>
                Close
              </Button>
            </Row>
          </div>
        )}
      </ModalFrame>
    );
  }
}

export default serviceCaller(withStyles(s)(addDonorModal));
